var lib_core = require("lib-core");

var $ = require('jquery');

var ToolbarView = function (model, tabView, stateMachine) {
    var self = this;

    this.model = model;
    this.tabView = tabView;
    this.stateMachine = stateMachine;
};

module.exports = ToolbarView;

ToolbarView.prototype.registerTool = function (tool, mode, offsetButtons) {
    var options = tool.getButtonElements();
    options.group = "tool";
    options.sortOrder = 0;
    options.eventType = (options.eventType || lib_core.GuiEvents.SET_TOOL);
    options.mode = mode ? mode.name() : null;
    options.eventData = {
        "tool": tool.name() + (mode ? "_"+mode.name() : "")
    };
    options.offsetButtons = offsetButtons;

    var button = this.tabView.registerButton(options);

    if(this.model.modes.size()) {
        if(!this.model.activeMode().getModel().tools.contains(tool)) {
            button.hide();
        }
    }
    this.model.activeMode.onChange(tool, function (value, old) {
        if(!value) button.show();
        else if (value.getModel().tools.contains(tool)) button.show();
        else button.hide();
    });

    this.model.activeTool.onChange({}, function (value, old) {
        if(value !== old)
            button.setInActive();
        else
            button.setActive();
    }, 10);
};

ToolbarView.prototype.addModeSwitcher = function (tool) {
    var self = this;

    var template = '<div class="editor__tab__toolbar__modeswitcher"> \
                    <select class="editor__tab__toolbar__select js-toolbar__modeswitcher__select" style="width: 200px; height: 40px;">';

    this.model.modes.forEach(function (idx, mode) {
        template += '<option value="'+mode.name()+'" name="'+mode.name()+'">'+mode.name()+'</option>';
    });

    template +=    '</select> \
                    </div>';

    var target = $('.editor__tab__toolbar editor__tab__toolbar--left', this.tabView.getToolbar().$el).prevObject;
    var $el = $(target).prepend($(template));

    $('.js-toolbar__modeswitcher__select', $el).on('change', function (e) {
        $(e.currentTarget).blur(); // blur to get rid of the focus
		$(e.currentTarget).trigger('Cioui:FootprintMode:value', $(e.currentTarget).val());
		$(e.currentTarget).trigger('Cioui:FootprintMode:label', $(e.currentTarget).find('option:selected').attr("name"));
	}
    );

    $el.on('Cioui:FootprintMode:value', function (e, value) {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.TOOLBAR_SWITCH_MODE)
                     .data('name', value);
        self.stateMachine.handle(cEvent);
    });
};
